<!--
  Schedule the deal's next action (RF-12, RF-39, RF-40).

  MatDialog provides the shell; everything inside is Hyper markup. The fields are the shared
  next-activity form (E4 RF-01, RF-04) — this dialog holds no type list or date input of its own.
-->
<div class="modal-header">
  <h4 class="modal-title">
    <i class="ri-flag-line me-1"></i>
    {{ 'kanban.nextAction.title' | translate }}
  </h4>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body">
  <!--
    Chained straight from a registered outcome: say why the dialog opened, otherwise
    it reads as an unexplained interruption (RF-40, AC-21).
  -->
  @if (isChained) {
    <div class="alert alert-info d-flex align-items-center" role="alert">
      <i class="ri-information-line me-2 font-18"></i>
      <span>{{ 'kanban.nextAction.chainedHint' | translate }}</span>
    </div>
  }

  <p class="text-muted mb-3">
    {{ 'kanban.nextAction.subtitle' | translate: { deal: $safeNavigationMigration(data?.card?.name) } }}
  </p>

  <app-next-activity-form [form]="form" [allowUntimed]="true" idPrefix="nextAction" />
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="close()" [disabled]="saving">
    {{ 'kanban.nextAction.cancel' | translate }}
  </button>
  <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving">
    @if (saving) {
      <span class="spinner-border spinner-border-sm me-1" role="status"></span>
    }
    {{ 'kanban.nextAction.save' | translate }}
  </button>
</div>
